<template>
  <component
    :is="$q.screen.gt.sm ? 'div' : 'q-carousel'"
    v-model="slide"
    :class="$q.screen.gt.sm ? 'flex justify-center q-gutter-xl q-pa-xl' : 'q-mx-sm'"
    transition-prev="slide-right"
    transition-next="slide-left"
    control-text-color="grey"
    :autoplay="false"
    animated
    infinite
    padding
    height="100%"
    swipeable
    arrows
  >
    <component
      :is="$q.screen.gt.sm ? 'div' : 'q-carousel-slide'"
      v-for="(item, index) in partners"
      :key="item"
      :name="index"
      :class="$q.screen.gt.sm ? 'partners--item q-pa-sm' : 'column flex-center'"
    >
      <img
        :src="`/img/partner_logo/partner-${item}.png`"
        class="partners--item-logo"
        :alt="item"
        contain
      >
    </component>
  </component>
</template>

<script>
export default {
  name: 'Partnership',
  data() {
    return {
      partners: [
        'mastercard',
        'swarovski',
        'philips',
        'redbull',
        's7',
        'paypal',
        'raiffeisen',
        'sber',
        'ozon',
        'aeroflot',
        'citi',
        'aireuropa',
        'travelport',
        'tune',
        'rakuten',
        'vipservice',
        'hsbc',
        'aspire',
      ],
      slide: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.partners--item {
  width: 115px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.partners--item-logo {
  max-width: 100%;
  max-height: 100%;
}

.q-carousel__slide {
  min-height: 240px;
}
</style>
